"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLocalStorage = void 0;
const clearLocalStorage = () => {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('removeDate');
    localStorage.removeItem('filters');
    localStorage.removeItem('isInitialLoad');
    localStorage.removeItem('tableFilters');
};
exports.clearLocalStorage = clearLocalStorage;
